import { TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import ClearIcon from '@mui/icons-material/Clear';
import { yyyymmdd } from '../Services/services';

const tm = 7776000000;

function formatDate(date) {
    if (!date) return '';
    var d = new Date(date);
    if (isNaN(d.getTime())) return '';
    
    var month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;

    return [year, month, day].join('-');
}

const today = formatDate(new Date())
const threeMonthsAgo = formatDate(new Date().getTime() - tm)

export default function DateRangePicker(props) {
    const [startDate, setStartDate] = useState(props.value?.startDate ? formatDate(props.value.startDate) : '');
    const [endDate, setEndDate] = useState(props.value?.endDate ? formatDate(props.value.endDate) : '');
    const inputRef = React.useRef(null);
    const inputRefs = React.useRef(null);
    
    // Sync internal state with props when they change
    useEffect(() => {
        if (props.value?.startDate) {
            const formatted = formatDate(props.value.startDate);
            if (formatted !== startDate) setStartDate(formatted);
        } else if (startDate !== '') {
            setStartDate('');
        }
        
        if (props.value?.endDate) {
            const formatted = formatDate(props.value.endDate);
            if (formatted !== endDate) setEndDate(formatted);
        } else if (endDate !== '') {
            setEndDate('');
        }
    }, [props.value]);

    useEffect(() => {
        // Only call getData if the values actually changed from what's in props
        const currentPropStart = props.value?.startDate ? formatDate(props.value.startDate) : '';
        const currentPropEnd = props.value?.endDate ? formatDate(props.value.endDate) : '';
        
        if (startDate !== currentPropStart || endDate !== currentPropEnd) {
            props.getData({ startDate: startDate, endDate: endDate });
        }
    }, [startDate, endDate])
    
    useEffect(() => {
        setStartDate('');
        setEndDate('');

        if (inputRef.current) {
            inputRef.current.value = '';
            inputRefs.current.value = '';
        }
    }, [props.clearDate])

    return (
        <div className='flex justify-center items-center'>
            <TextField type='date' size='small' className='w-40 bg-white'
                input={startDate}
                value={startDate}
                inputRef={inputRef}
                InputProps={{ inputProps: { max: endDate || undefined } }}
                onChange={(event) => setStartDate(event.target.value)}
            />
            <Typography>-</Typography>
            <TextField type='date' size='small' className='w-40 bg-white' 
                onChange={(event) => setEndDate(event.target.value)}
                value={endDate}
                inputRef={inputRefs}
                InputProps={{ inputProps: { min: startDate || undefined } }}
            />
            {
                (startDate || endDate) && (
                    <ClearIcon className='z-50 text-[#3366ff] cursor-pointer hover:text-black'
                        onClick={() => {
                            console.log("clickedd")
                            
                            setStartDate('');
                            setEndDate('');
                            if (inputRef.current) {
                                inputRef.current.value = '';
                                inputRefs.current.value = '';
                            }
                        }} />
                )
            }
        </div>
    )
}